import { toTitleCase } from "../../js/utils/titleCase";

export default function SharedCard({
  title,
  eyebrow,
  children,
  className = "",
  as: Tag = "article",
  style,
}) {
  return (
    <Tag className={`shared-card${className ? ` ${className}` : ""}`} style={style}>
      {eyebrow ? <p className="shared-card-eyebrow">{eyebrow}</p> : null}
      {title ? <h2 className="shared-card-title">{toTitleCase(title)}</h2> : null}
      {children}
    </Tag>
  );
}
